export const CategorySelectAttempt = 'CategorySelectAttempt'
export const CategorySelectBegin = 'CategorySelectBegin'
export const CategorySelectClick = 'CategorySelectClick'
export const CategorySelectFail = 'CategorySelectFail'
export const CategorySelectSuccess = 'CategorySelectSuccess'
